import React from "react";
import { ScanReportType } from "@sscs/types";
import {
  DangerousIcon as MUIDangerousOutlinedIcon,
  EditIcon as MUIModeEditOutlinedIcon,
  NearMeIcon as MUINearMeOutlinedIcon,
  RefreshIcon as MUIRefreshIcon,
} from "@sscs/ui/icons";
import { ActionMenu } from "Components";
import { useDialog } from "Hooks";
import { ActionItem, SharedToken } from "Types";
import { isSharedReportLinkExpired } from "../../../../utils";
import DeleteReportLinkDialog from "../../DeleteReportLinkDialog/DeleteReportLinkDialog";
import ManageInvitesDialog from "../../ManageInvitesDialog/ManageInvitesDialog";
import RegenerateReportLinkDialog from "../../RegenerateReportDialog/RegenerateReportLinkDialog";
import RenameReportLinkDialog from "../../RenameReportLinkDialog/RenameReportLinkDialog";
import StopSharingReportDialog from "../../StopSharingReportDialog/StopSharingReportDialog";

type LinkActionsProps = {
  link: SharedToken;
  versionId: string;
  purl: string;
  reportType?: ScanReportType;
};

const LinkActions = ({
  link,
  versionId,
  purl,
  reportType,
}: LinkActionsProps): React.JSX.Element => {
  const stopSharingReportDialog = useDialog();
  const renameReportLinkDialog = useDialog();
  const resendLinkDialog = useDialog();

  const deleteReportLinkDialog = useDialog();
  const regenerateReportLinkDialog = useDialog();

  const actions: ActionItem[] = !isSharedReportLinkExpired(link)
    ? [
        {
          id: "stop-sharing",
          type: "CUSTOM",
          text: "Stop sharing",
          itemIcon: <MUIDangerousOutlinedIcon />,
          onClick: stopSharingReportDialog.open,
        },
        {
          id: "rename-report-link",
          type: "CUSTOM",
          text: "Rename link",
          itemIcon: <MUIModeEditOutlinedIcon />,
          onClick: renameReportLinkDialog.open,
        },
        {
          id: "resend-report-link",
          type: "CUSTOM",
          text: "Send link",
          itemIcon: <MUINearMeOutlinedIcon />,
          onClick: resendLinkDialog.open,
        },
      ]
    : [
        {
          id: "delete-link",
          type: "DELETE",
          text: "Delete",
          onClick: deleteReportLinkDialog.open,
        },
        {
          id: "regenerate-report-link",
          type: "CUSTOM",
          text: "Regenerate",
          itemIcon: <MUIRefreshIcon />,
          onClick: regenerateReportLinkDialog.open,
        },
      ];

  return (
    <>
      <StopSharingReportDialog
        purl={purl}
        token={link.token}
        linkName={link.settings.label}
        onClose={stopSharingReportDialog.close}
        isOpen={stopSharingReportDialog.isOpen}
      />
      <RegenerateReportLinkDialog
        purl={purl}
        versionId={versionId}
        reportType={reportType}
        onClose={regenerateReportLinkDialog.close}
        isOpen={regenerateReportLinkDialog.isOpen}
        expiredReport={link}
      />
      <RenameReportLinkDialog
        purl={purl}
        token={link.token}
        currentLinkName={link.settings.label}
        onClose={renameReportLinkDialog.close}
        isOpen={renameReportLinkDialog.isOpen}
      />
      <DeleteReportLinkDialog
        purl={purl}
        token={link.token}
        linkName={link.settings.label}
        onClose={deleteReportLinkDialog.close}
        isOpen={deleteReportLinkDialog.isOpen}
      />
      <ManageInvitesDialog
        sharedReport={link}
        purl={purl}
        onClose={resendLinkDialog.close}
        isOpen={resendLinkDialog.isOpen}
      />
      <ActionMenu items={actions} />
    </>
  );
};

export default LinkActions;
